var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "less_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 140967",
    transform: "translate(-.249 -.249)",
    fill: "none",
    stroke: "#fff",
    d: "M0 0h12v12H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icon less",
    transform: "translate(.249 .249)",
    clipPath: "url(#less_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26225",
    d: "M2.979 5.751h6",
    fill: "none",
    stroke: "#378ff7",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
export default __webpack_public_path__ + "static/media/less.6f21cf7b.svg";
export { SvgLess as ReactComponent };